import React from 'react';
// import { useNavigate } from 'react-router-dom';


const Home = () => {
    const first_name = localStorage.getItem('resfirstName')
    const last_name = localStorage.getItem('reslastName')

    // const history = useNavigate();

    // useEffect(() => {
    //     if (token === null) {
    //         NotificationsAlert("warning", "Desconectado", "Faça login para continuar!")
    //         history("/login");
    //     } else {
    //         getCliInfos()
    //         setInterval(() => {
    //         }, 30000);
    //     }
    //     // eslint-disable-next-line
    // }, []);





    // const getCliInfos = async () => {
    //     const response = await Conect.post(`/aW5mb2NsaWVudGU=${token}`, {
    //         id: id_cli
    //     })

    //     console.log(response)
    //     // eslint-disable-next-line
    //     if (response.data.erro === true) {
    //         NotificationsAlert("warning", "Atenção", response.data.msg)
    //     }
    //     else {
    //         setCliData(response.data.data)
    //         // eslint-disable-next-line
    //     }
    // }


    return (
        <div>
            <h1 style={{color: 'white'}}>{`Olá ${first_name} ${last_name}.`}</h1>
        </div>
    );
}

export default Home;